export default {
    NO_AUTOREGULATION: 'NO_AUTOREGULATION',
    WEIGHT_AUTOREGULATION: 'WEIGHT_AUTOREGULATION',
    WEIGHT_AUTOREGULATION_SPEED: 'WEIGHT_AUTOREGULATION_SPEED',
};
